import { render } from "./HelloWorld.vue?vue&type=template&id=ae3498d0&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ae3498d0&scoped=true&lang=css"

import exportComponent from "D:\\AlterLau\\walter-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3498d0"]])

export default __exports__